import React from 'react'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';


const LeftMenu = () => {
  return (
    <Sidebar>
    <Menu>

      <SubMenu label="Slides">
        <Link to='/admin-slides'>
          <MenuItem> Administrar</MenuItem>
        </Link>
      </SubMenu>

      <SubMenu label="Paquetes">
        <Link to='/admin-packs'>
          <MenuItem> Administrar</MenuItem>
        </Link>
      </SubMenu>

      <SubMenu label="Galeria">
        <Link to='/admin-galery'>
          <MenuItem> Administrar</MenuItem>
        </Link>
      </SubMenu>

      <SubMenu label="Eventos">
      <Link to='/admin-events'>
          <MenuItem> Administrar</MenuItem>
        </Link>

      </SubMenu>

      <SubMenu label="Inventario">
      <Link to='/admin-inventario'>
          <MenuItem> Administrar</MenuItem>
        </Link>
      </SubMenu>
    </Menu>
  </Sidebar>
  )
}

export default LeftMenu